import { render, staticRenderFns } from "./EmployeeNameText.vue?vue&type=template&id=2d7926af&scoped=true"
import script from "./EmployeeNameText.vue?vue&type=script&lang=js"
export * from "./EmployeeNameText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7926af",
  null
  
)

export default component.exports